/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetResellerServiceprovidersAsAdmin200ResponseInner
 */
export interface GetResellerServiceprovidersAsAdmin200ResponseInner {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    verified: boolean;
    /**
     * 
     */
    created?: string | null;
    /**
     * Clients without an expired subscription.
     */
    activeClientCount: number;
}

/**
 * Check if a given object implements the GetResellerServiceprovidersAsAdmin200ResponseInner interface.
 */
export function instanceOfGetResellerServiceprovidersAsAdmin200ResponseInner(value: object): value is GetResellerServiceprovidersAsAdmin200ResponseInner {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('verified' in value) || value['verified'] === undefined) return false;
    if (!('activeClientCount' in value) || value['activeClientCount'] === undefined) return false;
    return true;
}

export function GetResellerServiceprovidersAsAdmin200ResponseInnerFromJSON(json: any): GetResellerServiceprovidersAsAdmin200ResponseInner {
    return GetResellerServiceprovidersAsAdmin200ResponseInnerFromJSONTyped(json, false);
}

export function GetResellerServiceprovidersAsAdmin200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResellerServiceprovidersAsAdmin200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'name': json['name'],
        'verified': json['verified'],
        'created': json['created'] === undefined ? undefined : json['created'] === null ? null : json['created'],
        'activeClientCount': json['activeClientCount'],
    };
}

export function GetResellerServiceprovidersAsAdmin200ResponseInnerToJSON(json: any): GetResellerServiceprovidersAsAdmin200ResponseInner {
    return GetResellerServiceprovidersAsAdmin200ResponseInnerToJSONTyped(json, false);
}

export function GetResellerServiceprovidersAsAdmin200ResponseInnerToJSONTyped(value?: GetResellerServiceprovidersAsAdmin200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'verified': value['verified'],
        'created': value['created'],
        'activeClientCount': value['activeClientCount'],
    };
}

